import { useBlocker } from '@faceup/router'
import { useModal } from '@faceup/ui-base'
import { useEffect } from 'react'

type PromptProps = {
  message: string

  when: boolean

  title?: string
}

// react-router 7 keeps only the last-registered blocker, so mount the blocker
// (and its modal) only when there is actually something to block.
export const Prompt = ({ message, when, title }: PromptProps) => {
  if (!when) {
    return null
  }
  return <ActivePrompt message={message} title={title} />
}

const ActivePrompt = ({ message, title }: Pick<PromptProps, 'message' | 'title'>) => {
  const blocker = useBlocker(true)
  const modal = useModal()

  // biome-ignore lint/correctness/useExhaustiveDependencies: useModal() returns a new object every render; the effect captures the current one when navigation is blocked, and listing it would re-open the modal on every render.
  useEffect(() => {
    if (blocker.state !== 'blocked') {
      return
    }
    const instance = modal.confirm.warning({
      title,
      content: message,
      onConfirm: () => blocker.proceed?.(),
      onCancel: () => blocker.reset?.(),
    })
    return () => instance.destroy()
  }, [blocker, message, title])

  return null
}
